// extracted by mini-css-extract-plugin
export default {"upload":"upload_q1p1C","uploadContent":"uploadContent_VTobd"};